import { render, staticRenderFns } from "./updateRoomDig.vue?vue&type=template&id=45eadf74&scoped=true"
import script from "./updateRoomDig.vue?vue&type=script&lang=js"
export * from "./updateRoomDig.vue?vue&type=script&lang=js"
import style0 from "./updateRoomDig.vue?vue&type=style&index=0&id=45eadf74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eadf74",
  null
  
)

export default component.exports